module.exports = __webpack_public_path__ + "static/media/mario_nezmah.d406c1f6.png";